import * as React from 'react';
var OrderContext = /*#__PURE__*/React.createContext(null);
export default OrderContext;